const accountingNL = {
    "view": {
        "table": {
            "title": "Boekhoudlijst",
            "column": {
                "release": "Release",
                "period": "Periode",
                "royalties": "Royalty's",
                "costs": "Kosten",
                "net_revenue": "Netto-omzet",
                "status": "Status",
                "accounting_report": "Boekhoudrapport",
                "details": "Details"
            },
            "placeholder": {
                "search": "Zoeken..."
            },
            "button": {
                "statusCreating": "Aanmaken",
                "statusGenerating": "Genereren",
                "statusGenerated": "Gegenereerd",
                "statusNotGenerated": "Niet gegenereerd",
                "open": "Openen",
                "downloadPDF": "PDF downloaden",
                "generatingPDF": "PDF genereren",
                "exportCsv": "Exporteer CSV"
            }
        },
        "message": {
            "subscriptionUpgrade": "Uw huidige abonnementsplan ondersteunt deze functie niet. Gelieve uw abonnementsplan te <1>upgraden</1> om deze functie te gebruiken.",
            "subscriptionExpired": "Uw abonnement is verlopen. Gelieve uw abonnement te <1>hervatten</1> om deze functie te gebruiken.",
            "noAccess": "U heeft geen toegang tot deze module, neem contact op met het ondersteuningsteam voor meer informatie."
        }
    },
    "add": {
        "form": {
            "label": {
                "filters": "Filters",
                "monthRange": "Maandbereik",
                "release": "Release"
            },
            "options": {
                "allReleases": "Alle releases"
            },
            "placeholder": {
                "startingMonth": "Beginnende maand",
                "endingMonth": "Eindmaand"
            },
            "button": {
                "generate": "Boekhoudrapport genereren",
                "reset": "Filters resetten"
            },
            "table": {
                "title": "Inkomsten beschikbaar voor boekhouding",
                "columns": {
                    "month": "Maand",
                    "year": "Jaar",
                    "revenue": "Inkomsten",
                    "status": "Status"
                },
                "label": {
                    "status_open": "Open",
                    "status_accounted": "Verantwoord",
                    "month_january": "Januari",
                    "month_february": "Februari",
                    "month_march": "Maart",
                    "month_april": "April",
                    "month_may": "Mei",
                    "month_june": "Juni",
                    "month_july": "Juli",
                    "month_august": "Augustus",
                    "month_september": "September",
                    "month_october": "Oktober",
                    "month_november": "November",
                    "month_december": "December"
                }
            }
        },
        "modal": {
            "header": "Boekhouding toevoegen",
            "body": "Weet u zeker dat u nieuwe boekhouding wilt toevoegen voor Release: {{release}}, PERIODE: {{startingMonth}} TOT {{endingMonth}} ?"
        },
        "message": {
            "success": "Boekhouding is aangemaakt!",
            "errorSomethingWentWrong": "Er is iets misgegaan! Vernieuw de pagina en probeer het opnieuw!",
            "errorNoEarningsAvailable": "Geen inkomsten beschikbaar voor boekhouding.",
            "errorNoReleaseSelected": "Selecteer een specifieke release voor boekhouding."
        }
    },
    "breakdown": {
        "view": {
            "table": {
                "title": "Boekhoudspecificatie",
                "column": {
                    "revenueShareHolder": "Aandeelhouder",
                    "revenue": "Netto aandeelhouder royalty",
                    "reportPdf": "PDF downloaden",
                    "action": "Actie",
                    "emailSent": "E-mail verzonden"
                },
                "label": {
                    "downloadPDF": "PDF downloaden",
                    "generatingPDF": "PDF genereren"
                },
                "button": {
                    "exportCsv": "Exporteer CSV"
                },
                "modal": {
                    "confirm": {
                        "header": "Rapport naar aandeelhouder sturen",
                        "body": "Weet u zeker dat u het rapport naar de aandeelhouder wilt sturen?",
                        "message": {
                            "success": "Rapport succesvol verzonden!"
                        },
                        "button": {
                            "cancel": "Annuleren",
                            "confirm": "Bevestigen"
                        }
                    }
                },
                "message": {
                    "success": "Boekhoudrapport is verzonden!",
                    "errorSomethingWentWrong": "Er is iets misgegaan! Vernieuw de pagina en probeer het opnieuw!",
                    "errorEmailNotPresent": "E-mail voor aandeelhouder niet aanwezig!",
                    "errorNoReportAvailable": "Geen rapport beschikbaar voor deze release."
                }
            }
        }
    }
};

export default accountingNL;